import type { AssistantPendingDTO } from '@contracts/assistant';
import { cn } from '../../lib/utils';
import { reasonLine } from './autonomy/labels';
import { EXT_CARD_LABELS } from './ext-card-labels';

/**
 * Why a card asks, the same on every internal card (internal, order, mission, mission diff; D226): S6 §7.5's taint
 * line names the outside servers the conversation read, and S7 §9.5's info band says why autonomy asked (D13: a
 * tainted reason only where the taint line is absent). `inset` is for a card whose body has no padding of its own:
 * the lines take the card's 12 px gutter; `className` spaces the block from what follows. Nothing to say renders
 * nothing.
 */
export function PendingWhy({ pending, inset = false, className }: {
  pending: Pick<AssistantPendingDTO, 'taint' | 'peerTaint' | 'reason'>; inset?: boolean; className?: string;
}) {
  const taint = pending.taint !== undefined && pending.taint.length > 0 ? pending.taint : null;
  const reason = reasonLine(pending.reason, pending.taint, pending.peerTaint);
  if (taint === null && reason === null) return null;
  const lines = (
    <>
      {taint !== null && (
        <p className={cn('text-xs text-[hsl(var(--h-muted-foreground))]', inset && 'pt-1')}>
          {EXT_CARD_LABELS.taint(taint)}
        </p>
      )}
      {reason !== null && (
        <p data-reason={pending.reason?.code}
          className={cn('rounded-md bg-[hsl(var(--h-info-soft))] px-2.5 py-2 text-xs leading-normal text-[hsl(var(--h-info-fg))]',
            inset && 'mt-1.5')}>
          {reason}
        </p>
      )}
    </>
  );
  return inset || className !== undefined ? <div className={cn(inset && 'px-3', className)}>{lines}</div> : lines;
}
